import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {
  AlertController,
  IonicPage,
  ModalController,
  ModalOptions,
  NavParams,
  ViewController,
} from "ionic-angular";
import * as momentTZ from "moment-timezone";
import { BillingService } from "providers/billing/billing-service";
import { UtilityService } from "providers/utility-service/utility-service";

@IonicPage()
@Component({
  selector: "add-claim-notes",
  templateUrl: "add-claim-notes.html",
})
export class AddClaimNotes {
  selected = 0;
  addNoteForm: FormGroup;
  claimIds = [];
  enableSave: boolean = true;
  notesCharacterCount: number = 0;
  notesCharacterMax: number = 150;
  id: number = 0;
  notesData: any;
  private initialNoteValue: string = "";

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public billingService: BillingService,
    public utilityService: UtilityService,
    public alertController: AlertController,
    public modalCtrl: ModalController
  ) {
    this.addNoteForm = new FormGroup({
      note: new FormControl(""),
    });
    this.selected = this.navParams.data.claims;
    if (this.navParams.data.note) {
      this.id = this.navParams.data.note.id;
      this.addNoteForm.controls["note"].setValue(
        this.navParams.data.note.notes
      );
    }
    this.claimIds = Object.keys(this.selected);

    // Capture initial value for dirty detection
    this.initialNoteValue = this.addNoteForm.controls["note"].value || "";

    // Seed derived UI state from the pre-filled note. On the edit path the note
    // value is set above, but the character-count subscription is not wired up
    // until ngOnInit, so it would otherwise miss the initial value (counter
    // stuck at "0 / 150") and the Save button would stay disabled until the
    // user re-typed. Initialise both from the seeded value.
    this.notesCharacterCount = this.initialNoteValue.length;
    this.enableSaveButton();
  }

  onDismiss() {
    if (this.hasFormChanges()) {
      this.presentDiscardChangesPopover();
    } else {
      this.viewCtrl.dismiss();
    }
  }

  ngOnInit() {
    this.addNoteForm.controls["note"].valueChanges.subscribe((value) => {
      this.notesCharacterCount = value ? value.length : 0;
    });
  }

  addNote() {
    this.utilityService.increaseSpinnerCount("Saving...");
    var body = [];
    this.claimIds.forEach((element) => {
      let claimObject = {
        claimId: parseInt(element),
        note: this.addNoteForm.controls["note"].value,
        timeZone: momentTZ.tz(momentTZ.tz.guess()).zoneAbbr(),
      };
      if (this.id > 0) {
        claimObject["id"] = this.id;
        delete claimObject["timeZone"];
      }
      body.push(claimObject);
    });

    if (this.id > 0) {
      this.billingService.editClaimNotes(body).subscribe(
        () => {
          this.utilityService.decreaseSpinnerCount();
          this.showAlert(
            {
              title: "Success",
              message: "Claim note edited successfully.",
            },
            null
          );
          this.viewCtrl.dismiss({ data: true });
        },
        (err) => {
          this.utilityService.decreaseSpinnerCount();
          this.showAlert(
            {
              title: "Error",
              message: "Unable to edit the claim note. Please try again.",
            },
            null
          );
        }
      );
    } else {
      this.billingService.saveClaimNotes(body).subscribe(
        () => {
          this.utilityService.decreaseSpinnerCount();
          this.showAlert(
            {
              title: "Success",
              message: "Claim note saved.",
            },
            null
          );
          this.viewCtrl.dismiss({ data: true });
        },
        (err) => {
          this.utilityService.decreaseSpinnerCount();
          this.showAlert(
            {
              title: "Error",
              message: "Unable to save the claim note. Please try again.",
            },
            null
          );
        }
      );
    }
  }

  enableSaveButton() {
    const noteValue = this.addNoteForm.controls["note"].value || "";
    this.enableSave = noteValue.length === 0;
  }

  showAlert = ({ title, message }, handler) => {
    let alert = this.alertController.create({
      title,
      message,
      enableBackdropDismiss: false,
      buttons: [
        {
          text: "Ok",
          handler: handler,
        },
      ],
    });
    alert.present();
  };

  private hasFormChanges(): boolean {
    const currentValue = this.addNoteForm.controls["note"].value || "";
    return currentValue !== this.initialNoteValue;
  }

  presentDiscardChangesPopover() {
    const modalOptions: ModalOptions = {
      enableBackdropDismiss: false,
      cssClass: "delete-facility-confirmation-popup",
    };

    let modalPage = this.modalCtrl.create(
      "CancelFacilityPage",
      { title: "Discard Changes" },
      modalOptions
    );

    modalPage.onDidDismiss((data) => {
      if (data && data.cancel) {
        this.viewCtrl.dismiss();
      }
    });

    modalPage.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/billing/claim-management/add-claim-notes/add-claim-notes.ts